import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'overline', 'Overline', [["path",{"d":"M7 9v5a5 5 0 0 0 10 0v-5"}],["path",{"d":"M5 5h14"}]]);